import React, { useState, useEffect } from 'react';
import { View, Text, TouchableOpacity, Linking } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { Image } from 'expo-image';
import AsyncStorage from '@react-native-async-storage/async-storage';
import usePlatform from '@/utils/hooks/usePlatform';
import Unicon from './Unicon';
import { usePathname } from 'expo-router';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.invendev.chmsnativeapp';
const BANNER_DISMISSED_KEY = '@androidAppBannerDismissed';

const AndroidAppBanner = () => {
    const [isVisible, setIsVisible] = useState(false);
    const { isWeb } = usePlatform();
    const pathname = usePathname();

    useEffect(() => {
        if (!isWeb) return;

        const checkBannerVisibility = async () => {
            const dismissed = await AsyncStorage.getItem(BANNER_DISMISSED_KEY);
            if (dismissed) {
                const dismissedDate = new Date(dismissed);
                const daysSinceDismissed = (Date.now() - dismissedDate.getTime()) / (1000 * 60 * 60 * 24);
                if (daysSinceDismissed < 7) {
                    return;
                }
            }

            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            
            if (/android/i.test(userAgent)) {
                setIsVisible(true);
            }
        };

        checkBannerVisibility();
    }, [isWeb]);

    const handleOpenApp = () => {
        const deepLinkUrl = `reachchms://${pathname}`;
        
        Linking.canOpenURL(deepLinkUrl).then((supported) => {
            if (supported) {
                Linking.openURL(deepLinkUrl);
            } else {
                Linking.openURL(PLAY_STORE_URL);
            }
        }).catch(() => {
            Linking.openURL(PLAY_STORE_URL);
        });
    };

    const handleDismiss = async () => {
        await AsyncStorage.setItem(BANNER_DISMISSED_KEY, new Date().toISOString());
        setIsVisible(false);
    };

    if (!isVisible || !isWeb) return null;

    return (
        <View style={styles.container}>
            <TouchableOpacity onPress={handleDismiss} style={styles.closeButton}>
                <Unicon name="times" size={18} color="#666" />
            </TouchableOpacity>
            
            <Image
                source={require('@/assets/AppIcons/splash-icon-dark.png')}
                style={styles.appIcon}
                contentFit="contain"
            />
            
            <View style={styles.textContainer}>
                <Text style={styles.appName}>Reach</Text>
                <Text style={styles.appDescription}>Open in Google Play</Text>
            </View>
            
            <TouchableOpacity onPress={handleOpenApp} style={styles.openButton}>
                <Text style={styles.openButtonText}>GET</Text>
            </TouchableOpacity>
        </View>
    );
};

const styles = StyleSheet.create(({ colors }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: colors.surface,
        paddingVertical: 10,
        paddingHorizontal: 12,
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
        gap: 10,
    },
    closeButton: {
        padding: 4,
    },
    appIcon: {
        width: 40,
        height: 40,
        borderRadius: 8,
    },
    textContainer: {
        flex: 1,
    },
    appName: {
        fontSize: 14,
        fontFamily: 'Geist_semibold',
        color: colors.text,
    },
    appDescription: {
        fontSize: 12,
        fontFamily: 'Geist_regular',
        color: colors.textSecondary,
    },
    openButton: {
        backgroundColor: colors.primary,
        paddingHorizontal: 16,
        paddingVertical: 6,
        borderRadius: 16,
    },
    openButtonText: {
        color: '#fff',
        fontSize: 13,
        fontFamily: 'Geist_semibold',
    },
}));

export default AndroidAppBanner;
